import $ from "jquery";
import anime from 'animejs/lib/anime.es.js';
import "isotope-layout/dist/isotope.pkgd";

$(document).ready(function () {
	let mobilRender = false;
	if ($(window).width() <= 490) {
		mobilRender = true;

		$("#hero-video-player").attr(
			"src",
			"https://player.vimeo.com/video/" +
				$("#hero-video").data("moblievideo") +
				"?background=1&autoplay=1&loop=1&byline=0&title=0?muted=1?rel=0/",
		);
	}

	$(window).resize(function () {
		if ($(window).width() <= 490) {
			if (!mobilRender) {
				mobilRender = true;
				$("#hero-video-player").attr(
					"src",
					"https://player.vimeo.com/video/" +
						$("#hero-video").data("moblievideo") +
						"?background=1&autoplay=1&loop=1&byline=0&title=0?muted=1?rel=0/",
				);
			}
		} else {
			if (mobilRender) {
				mobilRender = false;
				$("#hero-video-player").attr(
					"src",
					"https://player.vimeo.com/video/" +
						$("#hero-video").data("desktopvideo") +
						"?background=1&autoplay=1&loop=1&byline=0&title=0?muted=1?rel=0/",
				);
			}
		}
	});
	// TeasersOverlays
	var levelThumbs = ".level-teasers--teaser__inner";
	var levelAnimationEl = ".overlay-info, img";
	var levelOverlay = ".overlay-info";
	var animeItems = ".anime";

	var levelFunctions = {
		init: function () {
			levelFunctions.mason();
			levelFunctions.hovers();
			levelFunctions.anime();
		},
		mason: function () {
			$(".level-teasers").isotope({
				itemSelector: ".level-teasers__teaser",
				masonry: {
					columnWidth: ".grid-sizer",
				},
			});
		},
		anime: function () {
			$(animeItems).each(function (i, el) {
				var animationProperties = $(el).data("anime").split(";");
				var preset = animationProperties[0].split(":")[1];
				var delay = animationProperties[1].split(":")[1];

				if (preset === "fadeIn") {
					anime({
						targets: el,
						opacity: [0, 1],
						delay: delay,
						easing: "easeInOutExpo",
					});
				} else if (preset === "slideInUpShort") {
					anime({
						targets: el,
						opacity: 1,
						translateY: [50, 0],
						delay: delay,
						easing: "easeInOutExpo",
					});
				} else if (preset === "slideInRightShort") {
					anime({
						targets: el,
						opacity: 1,
						translateX: [50, 0],
						delay: delay,
						easing: "cubicBezier(.5, .05, .1, .3)",
					});
				} else if (preset === "slideInLeftShort") {
					anime({
						targets: el,
						opacity: 1,
						translateX: [-50, 0],
						delay: delay,
						easing: "cubicBezier(.5, .05, .1, .3)",
					});
				} else if (preset === "slideInDownShort") {
					anime({
						targets: el,
						opacity: 1,
						translateY: [-50, 0],
						delay: delay,
						easing: "cubicBezier(.5, .05, .1, .3)",
					});
				} else if (preset === "scaleIn") {
					anime({
						targets: el,
						opacity: 1,
						scale: [0.6, 1],
						delay: delay,
						easing: "cubicBezier(.5, .05, .1, .3)",
					});
				} else if (preset === "flipInX") {
					anime({
						targets: el,
						opacity: 1,
						rotateX: [-180, 0],
						delay: delay,
						easing: "cubicBezier(.5, .05, .1, .3)",
					});
				}
			});
		},
		hovers: function () {
			$(levelThumbs).each(function () {
				$(this).find(levelAnimationEl).css({
					transitionDuration: "1000ms",
					transitionTimingFunction: "easeInOut",
				});
				$(this).find(levelOverlay).css({
					backgroundColor: "rgba(0,0,0,.5)",
				});
			});
		},
	};
	levelFunctions.init();
});
